import { apiFetch } from "./apiClient";

export async function getAllServiceListTypes() {
  const res = await apiFetch(`/api/services/service/service-metadata`);
  if (!res.ok) {
    throw new Error("Failed to fetch service metadata");
  }
  const data = await res.json();
  return data;
}

export async function getAllTaskMetadata() {
  const res = await apiFetch(`/api/services/task/task-metadata`);
  if (!res.ok) {
    throw new Error("Failed to fetch task metadata");
  }
  const data = await res.json();
  console.log("Task Metadata Response:", data);
  return data;
}
